// extracted by mini-css-extract-plugin
export default {"cls1":"tmxmNl5HbtS_TyuU_Kyr","cls2":"lWnlHFNSUn_6qAV7dAwg tmxmNl5HbtS_TyuU_Kyr","isTabletDown":"pQzBDQ5QZYI65y1dB3P1","isDesktopUp":"LYYPrB5brB1sj27iTX0z"};